var _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.691,
    y: 83.832,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 717.1623 257.8902)",
    style: {
      fill: "#E6E6E6"
    },
    width: 137.781,
    height: 90.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.487,
    y: 83.832,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 710.9939 257.8902)",
    style: {
      fill: "#F0F0F0"
    },
    width: 140.02,
    height: 90.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.691,
    y: 174.059,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 717.1623 365.8246)",
    style: {
      fill: "#E6E6E6"
    },
    width: 137.781,
    height: 17.708
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.483,
    y: 174.059,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 696.9867 365.8246)",
    style: {
      fill: "#F0F0F0"
    },
    width: 140.02,
    height: 17.708
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.269,
    y: 64.82,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 484.4421 -226.5519)",
    style: {
      fill: "#FAFAFA"
    },
    width: 78.456,
    height: 128.249
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "390.702,168.174 374.322,89.718 348.761,89.718 365.141,168.174  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M416.897,162.315c0.232,0,0.421-0.188,0.421-0.42V93.547c0-0.232-0.188-0.42-0.421-0.42 c-0.232,0-0.421,0.188-0.421,0.42v68.348C416.476,162.127,416.665,162.315,416.897,162.315z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "359.65,168.174 343.27,89.718 333.304,89.718 349.685,168.174  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.518,
    y: 128.571,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 420.6911 -162.8009)",
    style: {
      fill: "#E6E6E6"
    },
    width: 78.456,
    height: 0.747
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "284.095,98.591 421.876,98.591 422.417,92.005 284.636,92.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "284.095,109.393 421.876,109.393 422.417,102.807 284.636,102.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "284.095,120.195 421.876,120.195 422.417,113.609 284.636,113.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "284.095,130.997 421.876,130.997 422.417,124.411 284.636,124.411  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "284.095,141.799 421.876,141.799 422.417,135.213 284.636,135.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "284.095,152.601 421.876,152.601 422.417,146.015 284.636,146.015  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.799,
    y: 316.781,
    style: {
      fill: "#E6E6E6"
    },
    width: 28.889,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.307,
    y: 251.333,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 653.9484 633.7317)",
    style: {
      fill: "#E6E6E6"
    },
    width: 5.333,
    height: 131.065
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.836,
    y: 316.781,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 639.2583)",
    style: {
      fill: "#F5F5F5"
    },
    width: 72.963,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.799,
    y: 347.948,
    style: {
      fill: "#E6E6E6"
    },
    width: 28.889,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.836,
    y: 347.948,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 701.5915)",
    style: {
      fill: "#F5F5F5"
    },
    width: 72.963,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.799,
    y: 254.448,
    style: {
      fill: "#E6E6E6"
    },
    width: 28.889,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.836,
    y: 254.448,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 514.5915)",
    style: {
      fill: "#F5F5F5"
    },
    width: 72.963,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.799,
    y: 285.615,
    style: {
      fill: "#E6E6E6"
    },
    width: 28.889,
    height: 5.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.836,
    y: 285.615,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 576.9249)",
    style: {
      fill: "#F5F5F5"
    },
    width: 72.963,
    height: 5.696
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 397.271,
    y: 251.333,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 799.8751 633.7317)",
    style: {
      fill: "#E6E6E6"
    },
    width: 5.333,
    height: 131.065
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.466,
    y: 251.333,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 752.2646 633.7317)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.333,
    height: 131.065
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.836,
    y: 251.333,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0045 633.7317)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.333,
    height: 131.065
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.374,
    y: 276.507,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 185.3254 658.9061)",
    style: {
      fill: "#E6E6E6"
    },
    width: 54.578,
    height: 105.892
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "79.948,382.399 65.374,382.399 65.374,367.781 95.228,367.781  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.184,
    y: 276.507,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 482.9448 658.9061)",
    style: {
      fill: "#E6E6E6"
    },
    width: 54.578,
    height: 105.892
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.374,
    y: 276.507,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 653.8746)",
    style: {
      fill: "#FAFAFA"
    },
    width: 161.529,
    height: 100.861
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "212.329,382.399 226.903,382.399 226.903,367.781 197.048,367.781  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 314.091,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 653.4225)",
    style: {
      fill: "#F0F0F0"
    },
    width: 138.917,
    height: 25.241
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 344.727,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 714.6938)",
    style: {
      fill: "#F0F0F0"
    },
    width: 138.917,
    height: 25.241
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M103.084,316.79h86.108c2.527,0,4.576-2.049,4.576-4.577v-0.308H98.508v0.308 C98.508,314.741,100.557,316.79,103.084,316.79z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 283.455,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 592.1511)",
    style: {
      fill: "#F0F0F0"
    },
    width: 138.917,
    height: 25.241
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M103.084,286.154h86.108c2.527,0,4.576-2.049,4.576-4.577v-0.308H98.508v0.308 C98.508,284.105,100.557,286.154,103.084,286.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M103.084,347.425h86.108c2.527,0,4.576-2.049,4.576-4.576v-0.308H98.508v0.308 C98.508,345.376,100.557,347.425,103.084,347.425z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.068,
    y: 83.832,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 285.9172 257.8902)",
    style: {
      fill: "#E6E6E6"
    },
    width: 137.781,
    height: 90.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.864,
    y: 83.832,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 279.7489 257.8902)",
    style: {
      fill: "#F0F0F0"
    },
    width: 140.02,
    height: 90.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.068,
    y: 174.059,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 285.9172 365.8246)",
    style: {
      fill: "#E6E6E6"
    },
    width: 137.781,
    height: 17.708
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.861,
    y: 174.059,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 265.7415 365.8246)",
    style: {
      fill: "#F0F0F0"
    },
    width: 140.02,
    height: 17.708
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.647,
    y: 64.82,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 268.8195 -10.9293)",
    style: {
      fill: "#FAFAFA"
    },
    width: 78.456,
    height: 128.249
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "175.08,168.174 158.699,89.718 133.138,89.718 149.519,168.174  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M201.274,162.315c0.232,0,0.42-0.188,0.42-0.42V93.547c0-0.232-0.188-0.42-0.42-0.42 c-0.232,0-0.421,0.188-0.421,0.42v68.348C200.854,162.127,201.042,162.315,201.274,162.315z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "144.028,168.174 127.647,89.718 117.682,89.718 134.063,168.174  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.896,
    y: 128.571,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 205.0685 52.8217)",
    style: {
      fill: "#E6E6E6"
    },
    width: 78.456,
    height: 0.747
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "68.472,98.591 206.253,98.591 206.795,92.005 69.014,92.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "68.472,102.307 206.253,102.307 206.795,95.72 69.014,95.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "68.472,106.022 206.253,106.022 206.795,99.436 69.014,99.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "68.472,109.738 206.253,109.738 206.795,103.151 69.014,103.151  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "68.472,113.453 206.253,113.453 206.795,106.867 69.014,106.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "68.472,117.168 206.253,117.168 206.795,110.582 69.014,110.582  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.013,
    y: 220.179,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.7898 493.45)",
    style: {
      fill: "#F5F5F5"
    },
    width: 4.763,
    height: 53.092
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.627,
    y: 220.142,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 194.5989 493.3764)",
    style: {
      fill: "#FAFAFA"
    },
    width: 1.345,
    height: 53.092
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.536,
    y: 220.142,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 197.5986 493.3766)",
    style: {
      fill: "#FAFAFA"
    },
    width: 0.527,
    height: 53.092
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M80.763,276.507h35.264v0c0-2.454-1.989-4.443-4.443-4.443H85.206 C82.752,272.064,80.763,274.053,80.763,276.507L80.763,276.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M89.835,253.138L89.835,253.138c0.754,0,1.37-0.617,1.37-1.37v-34.81c0-0.753-0.617-1.37-1.37-1.37 l0,0c-0.754,0-1.37,0.617-1.37,1.37v34.81C88.465,252.522,89.081,253.138,89.835,253.138z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "77.074,232.799 119.716,232.799 114.811,203 81.979,203  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M240.468,127.098c48.1,5.378,69.216-36.321,116.882-30.86 c42.544,4.874,71.876,35.185,61.948,76.006c-8.813,36.236-50.805,47.61-65.736,81.557c-15.827,35.985-28.104,74.793-75.902,87.32 c-93.855,24.597-139.441-90.884-145.828-157.21c-2.451-25.461-6.729-86.327,26.505-94.215 C191.787,81.756,210.963,123.799,240.468,127.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M240.468,127.098c48.1,5.378,69.216-36.321,116.882-30.86 c42.544,4.874,71.876,35.185,61.948,76.006c-8.813,36.236-50.805,47.61-65.736,81.557c-15.827,35.985-28.104,74.793-75.902,87.32 c-93.855,24.597-139.441-90.884-145.828-157.21c-2.451-25.461-6.729-86.327,26.505-94.215 C191.787,81.756,210.963,123.799,240.468,127.098z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__130_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Window_No_Data"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.782,
    y: 202.372,
    transform: "matrix(0.9974 -0.0718 0.0718 0.9974 -14.9322 8.0379)",
    style: {
      fill: "#407BFF"
    },
    width: 1,
    height: 18.489
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    y: 230.351,
    transform: "matrix(0.9974 -0.0719 0.0719 0.9974 -16.5285 8.2128)",
    style: {
      fill: "#407BFF"
    },
    width: 1,
    height: 6.955
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M337.711,315.161H123.553c-4.844,0-9.092-3.963-9.441-8.807l-10.523-146.13 c-0.349-4.844,3.329-8.807,8.173-8.807H325.92c4.844,0,9.092,3.963,9.441,8.807l10.523,146.13 C346.232,311.198,342.555,315.161,337.711,315.161z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M338.532,315.161H124.374c-4.844,0-9.092-3.963-9.441-8.807l-10.523-146.13 c-0.349-4.844,3.329-8.807,8.173-8.807h214.158c4.844,0,9.092,3.963,9.441,8.807l10.523,146.13 C347.053,311.198,343.376,315.161,338.532,315.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M338.532,315.161H124.374c-4.844,0-9.092-3.963-9.441-8.807l-10.523-146.13 c-0.349-4.844,3.329-8.807,8.173-8.807h214.158c4.844,0,9.092,3.963,9.441,8.807l10.523,146.13 C347.053,311.198,343.376,315.161,338.532,315.161z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M327.058,155.821H112.9c-0.242,0-0.481,0.01-0.717,0.029c-5.474,0.451-4.356,8.778,1.169,8.778 h214.523c5.525,0,5.444-8.327-0.095-8.778C327.541,155.831,327.3,155.821,327.058,155.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M118.478,160.225c0.08,1.115-0.758,2.019-1.874,2.019c-1.115,0-2.084-0.904-2.164-2.019 c-0.08-1.115,0.758-2.019,1.874-2.019S118.398,159.109,118.478,160.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M125.346,160.225c0.08,1.115-0.758,2.019-1.874,2.019c-1.115,0-2.084-0.904-2.164-2.019 c-0.08-1.115,0.758-2.019,1.874-2.019C124.297,158.206,125.266,159.109,125.346,160.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M132.214,160.225c0.08,1.115-0.759,2.019-1.874,2.019c-1.115,0-2.084-0.904-2.165-2.019 c-0.08-1.115,0.759-2.019,1.874-2.019S132.133,159.109,132.214,160.225z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.854,300.577H127.951c-1.763,0-3.296-1.43-3.423-3.193l-8.654-120.173 c-0.127-1.763,1.2-3.193,2.963-3.193h204.903c1.763,0,3.296,1.429,3.423,3.193l8.654,120.173 C335.944,299.147,334.617,300.577,332.854,300.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "246.53,254.798 243.195,208.479 233.087,202.395 205.283,202.395 209.057,254.798  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M246.53,255.283h-37.473c-0.254,0-0.465-0.196-0.483-0.45L204.8,202.43 c-0.01-0.134,0.037-0.267,0.129-0.365c0.092-0.099,0.22-0.154,0.355-0.154h27.804c0.088,0,0.175,0.024,0.25,0.07l10.107,6.083 c0.135,0.081,0.222,0.223,0.233,0.38l3.335,46.319c0.01,0.134-0.037,0.267-0.129,0.365 C246.793,255.227,246.664,255.283,246.53,255.283z M209.508,254.314h36.501l-3.28-45.549l-9.776-5.885h-27.149 L209.508,254.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "243.195,208.479 233.087,202.395 236.798,210.455  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M236.798,210.939c-0.185,0-0.359-0.107-0.44-0.282l-3.711-8.059 c-0.089-0.193-0.042-0.422,0.117-0.564c0.158-0.142,0.391-0.163,0.573-0.054l10.107,6.084 c0.164,0.098,0.254,0.284,0.231,0.474c-0.023,0.19-0.155,0.348-0.338,0.404l-6.396,1.976 C236.894,210.932,236.846,210.939,236.798,210.939z M234.186,203.622l2.875,6.244l4.956-1.531L234.186,203.622z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M220.969,226.005c0.084,1.169-0.795,2.117-1.965,2.117s-2.185-0.948-2.269-2.117 c-0.084-1.169,0.795-2.117,1.964-2.117S220.885,224.836,220.969,226.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M234.705,226.005c0.084,1.169-0.795,2.117-1.965,2.117c-1.169,0-2.185-0.948-2.27-2.117 c-0.084-1.169,0.795-2.117,1.965-2.117C233.605,223.889,234.621,224.836,234.705,226.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M238.58,239.735c-0.252,0-0.464-0.195-0.483-0.45c-0.245-3.404-5.583-6.173-11.9-6.173 c-4.185,0-7.942,1.244-9.806,3.247c-0.829,0.891-1.212,1.851-1.14,2.856c0.019,0.267-0.182,0.499-0.449,0.518 c-0.268,0.017-0.499-0.182-0.518-0.449c-0.091-1.266,0.392-2.506,1.397-3.586c2.041-2.194,6.07-3.556,10.516-3.556 c6.929,0,12.581,3.107,12.867,7.072c0.019,0.267-0.182,0.499-0.449,0.518C238.603,239.735,238.591,239.735,238.58,239.735z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M213.167,221.717c-0.118,0-0.236-0.043-0.33-0.129c-0.196-0.182-0.208-0.489-0.026-0.685 l2.124-2.288c0.182-0.197,0.489-0.207,0.685-0.026c0.196,0.182,0.207,0.489,0.026,0.685l-2.123,2.288 C213.427,221.665,213.297,221.717,213.167,221.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M237.584,221.717c-0.118,0-0.237-0.043-0.331-0.13l-2.453-2.288 c-0.196-0.182-0.206-0.489-0.024-0.685c0.182-0.196,0.489-0.206,0.685-0.024l2.453,2.288c0.196,0.182,0.206,0.489,0.024,0.685 C237.843,221.665,237.714,221.717,237.584,221.717z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M202.257,265.153h2.26l3.261,4.334l-0.312-4.334h2.281l0.564,7.833h-2.282l-3.243-4.301 l0.31,4.301h-2.276L202.257,265.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M211.334,269.074c-0.092-1.279,0.192-2.274,0.854-2.987c0.661-0.712,1.628-1.069,2.899-1.069 c1.304,0,2.333,0.35,3.089,1.05c0.756,0.7,1.179,1.68,1.27,2.941c0.066,0.915-0.034,1.666-0.3,2.252 c-0.266,0.586-0.678,1.042-1.237,1.368c-0.559,0.326-1.273,0.489-2.142,0.489c-0.883,0-1.625-0.141-2.224-0.422 c-0.599-0.281-1.1-0.727-1.504-1.336C211.635,270.752,211.4,269.99,211.334,269.074z M213.755,269.085 c0.057,0.791,0.245,1.359,0.563,1.704c0.319,0.346,0.731,0.518,1.237,0.518c0.52,0,0.91-0.169,1.171-0.508 c0.261-0.338,0.359-0.946,0.296-1.822c-0.053-0.737-0.241-1.276-0.563-1.616s-0.738-0.51-1.247-0.51 c-0.488,0-0.867,0.173-1.138,0.518C213.804,267.716,213.698,268.287,213.755,269.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M224.152,265.153h3.596c0.709,0,1.288,0.096,1.739,0.288c0.45,0.192,0.831,0.468,1.142,0.828 c0.311,0.36,0.548,0.778,0.71,1.256c0.163,0.477,0.263,0.983,0.302,1.517c0.06,0.837,0.012,1.486-0.146,1.948 c-0.157,0.461-0.394,0.848-0.71,1.159c-0.316,0.312-0.664,0.519-1.045,0.622c-0.52,0.143-0.996,0.214-1.427,0.214h-3.596 L224.152,265.153z M226.7,266.927l0.308,4.28h0.593c0.506,0,0.861-0.056,1.067-0.168c0.206-0.112,0.359-0.308,0.46-0.588 c0.101-0.28,0.129-0.733,0.084-1.36c-0.06-0.83-0.236-1.398-0.529-1.704c-0.293-0.306-0.753-0.459-1.38-0.459H226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M237.448,271.692H234.7l-0.289,1.293h-2.471l2.38-7.833h2.64l3.507,7.833h-2.535L237.448,271.692 z M236.824,269.999l-1.068-2.816l-0.653,2.816H236.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M239.369,265.153h7.357l0.139,1.934h-2.468l0.425,5.899h-2.42l-0.425-5.899h-2.468 L239.369,265.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M252.365,271.692h-2.748l-0.289,1.293h-2.471l2.38-7.833h2.64l3.507,7.833h-2.535 L252.365,271.692z M251.741,269.999l-1.067-2.816l-0.653,2.816H251.741z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M353.688,173.08c0.894-0.448,1.959-1.027,2.944-1.568c1.003-0.551,2.001-1.126,2.983-1.724 c1.959-1.206,3.934-2.398,5.808-3.722c3.782-2.605,7.325-5.496,10.513-8.653c0.418-0.382,0.773-0.806,1.159-1.21l0.57-0.612 l0.286-0.306l0.143-0.153c0.038-0.04,0.029-0.032,0.011-0.008l-0.032,0.049c-0.142,0.267-0.024,0.186,0.031-0.072 c0.067-0.248,0.123-0.653,0.141-1.091c0.064-1.816-0.294-4.105-0.729-6.318c-0.89-4.485-2.238-9.098-3.57-13.618l3.885-1.704 c2.434,4.346,4.462,8.785,6.113,13.598c0.786,2.438,1.508,4.886,1.719,7.893c0.039,0.766,0.056,1.571-0.083,2.51 c-0.147,0.924-0.38,2.03-1.223,3.284l-0.167,0.231l-0.129,0.168l-0.154,0.188l-0.308,0.374l-0.617,0.75 c-0.417,0.494-0.813,1.015-1.256,1.478c-3.448,3.829-7.284,7.211-11.379,10.152c-2.038,1.489-4.12,2.903-6.283,4.19 c-1.077,0.652-2.168,1.278-3.277,1.885c-1.123,0.624-2.191,1.167-3.467,1.766L353.688,173.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M344.794,408.178c0.774,0,1.62-0.16,2.211-0.3c0.077-0.018,0.136-0.08,0.15-0.159 c0.014-0.078-0.02-0.157-0.086-0.2c-0.287-0.189-2.83-1.83-3.805-1.389c-0.154,0.07-0.347,0.223-0.395,0.558 c-0.063,0.444,0.048,0.798,0.329,1.054C343.555,408.068,344.15,408.178,344.794,408.178z M346.444,407.595 c-1.458,0.291-2.555,0.241-2.979-0.146c-0.18-0.164-0.247-0.395-0.203-0.706c0.023-0.167,0.101-0.222,0.165-0.251 C343.94,406.26,345.407,406.968,346.444,407.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M346.96,407.884c0.034,0,0.069-0.009,0.1-0.027c0.061-0.036,0.099-0.101,0.099-0.172 c0-0.102-0.011-2.514-0.922-3.32c-0.242-0.214-0.524-0.303-0.84-0.265c-0.497,0.06-0.631,0.373-0.668,0.553 c-0.189,0.944,1.334,2.751,2.133,3.204C346.892,407.875,346.926,407.884,346.96,407.884z M345.535,404.488 c0.163,0,0.307,0.057,0.439,0.174c0.544,0.481,0.73,1.835,0.776,2.638c-0.797-0.636-1.746-1.994-1.631-2.569 c0.019-0.094,0.073-0.206,0.326-0.237C345.475,404.49,345.505,404.488,345.535,404.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M346.223,148.067c-0.974,4.97-3.028,15.037,0.45,18.354c0,0-1.359,5.042-10.594,5.042 c-10.155,0-4.853-5.041-4.853-5.041c5.543-1.324,5.4-5.436,4.434-9.298L346.223,148.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M329.284,168.424c-1.594,0.216-0.238-3.913,0.41-4.341c1.496-0.989,20.851-2.389,20.725-0.04 c-0.08,1.011-0.555,2.984-1.401,3.654C348.171,168.367,343.199,166.342,329.284,168.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M332.437,167.034c-1.266,0.428-1.146-3.733-0.715-4.234c0.998-1.158,16.664-5.183,17.129-2.906 c0.179,0.983,0.265,2.947-0.272,3.71C348.042,164.366,343.439,163.105,332.437,167.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M326.61,139.108c-0.123,0.007-0.247-0.042-0.331-0.145c-1.12-1.37-2.576-1.23-2.59-1.228 c-0.221,0.023-0.414-0.134-0.437-0.352c-0.024-0.218,0.134-0.414,0.352-0.437c0.077-0.008,1.9-0.185,3.29,1.514 c0.139,0.17,0.114,0.42-0.056,0.558C326.771,139.074,326.691,139.103,326.61,139.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5652"
    },
    d: "M324.672,144.001c0,0-0.856,3.007-1.975,4.527c0.969,0.741,2.441,0.214,2.441,0.214 L324.672,144.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M325.16,142.786c0.066,0.672-0.237,1.252-0.676,1.296c-0.44,0.043-0.849-0.467-0.916-1.139 c-0.066-0.672,0.237-1.252,0.676-1.296C324.684,141.604,325.094,142.114,325.16,142.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M324.443,141.665l-1.661-0.307C322.782,141.359,323.735,142.539,324.443,141.665z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "356.7,407.685 348.324,407.685 348.981,388.288 357.357,388.288  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.661,406.716h9.41c0.342,0,0.62,0.238,0.668,0.572l1.072,7.445 c0.111,0.772-0.553,1.503-1.343,1.49c-3.281-0.056-4.862-0.249-9-0.249c-2.546,0-6.266,0.264-9.781,0.264 c-3.439,0-3.703-3.477-2.239-3.791c6.564-1.412,7.601-3.359,9.813-5.216C346.659,406.896,347.16,406.716,347.661,406.716z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "357.359,388.293 348.979,388.293 348.645,398.292 357.025,398.292  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M323.374,178.044c-5.183-2.029-10.127-4.236-15.05-6.754c-4.915-2.515-9.754-5.194-14.404-8.773 c-1.158-0.911-2.303-1.907-3.422-3.07c-0.279-0.3-0.558-0.578-0.832-0.922c-0.288-0.362-0.505-0.575-0.879-1.131 c-0.676-0.972-1.199-2.277-1.338-3.609c-0.131-1.333,0.108-2.606,0.491-3.621c0.382-1.033,0.883-1.876,1.407-2.607 c1.051-1.464,2.216-2.546,3.389-3.52c2.343-1.939,4.821-3.349,7.303-4.667c1.24-0.658,2.504-1.251,3.784-1.797 c1.286-0.555,2.541-1.071,3.906-1.541l1.775,3.853c-4.362,2.749-8.88,5.771-12.202,9.159c-0.807,0.839-1.513,1.717-1.957,2.49 c-0.476,0.787-0.47,1.376-0.389,1.331c0.041,0,0.025-0.018,0.141,0.098l0.398,0.427c0.15,0.179,0.361,0.362,0.55,0.546 c0.785,0.733,1.706,1.469,2.699,2.169c1.985,1.413,4.172,2.735,6.434,3.97c2.254,1.252,4.573,2.45,6.935,3.587 c4.712,2.257,9.598,4.429,14.392,6.413L323.374,178.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M311.969,137.154l1.385-3.004l-6.296-2.186c0,0-1.961,5.903,0.376,8.627l0,0 C309.424,140.272,311.125,138.984,311.969,137.154z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "313.354,127.656 308.321,126.205 307.058,131.963 313.354,134.15  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M378.35,134.441l0.734-7.02l-6.488,1.525c0,0-0.095,6.58,3.337,7.629L378.35,134.441z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "375.958,122.507 371.731,124.481 372.595,128.946 379.083,127.421  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M347.54,138.255c0.305,8.307,0.612,11.817-3.142,16.466c-5.646,6.992-15.917,5.55-18.698-2.499 c-2.503-7.245-2.582-19.613,5.178-23.695C338.523,124.507,347.235,129.947,347.54,138.255z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.921,154.705c8.155-3.524,13.519-10.955,11.255-22.574 c-2.166-11.116-9.671-12.214-12.771-9.908c-3.1,2.306-10.827-1.131-15.464,2.771c-8.035,6.761-0.439,14.05,3.518,18.369 C332.823,148.221,335.919,158.163,343.921,154.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M340.535,130.137c2.752,3.985,8.03,5.11,11.79,2.513c3.76-2.596,4.577-7.931,1.825-11.916 c-2.752-3.985-8.03-5.11-11.79-2.513C338.6,120.817,337.783,126.152,340.535,130.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.652,123.002c-1.177-6.698,5.161-11.863,13.636-9.367c8.475,2.496,3.992,10.009,2.254,16.009 c-1.738,6,2.823,11.715,4.729,7.145c1.906-4.569-1.298-5.98-1.298-5.98s8.999,2.333,0.639,12.477 c-8.36,10.145-15.928-1.057-13.881-7.668C350.385,130.276,343.765,129.333,342.652,123.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M334.182,125.533c-3.869-2.018-10.421-3.65-14.15,2.623c-1.763,2.966-1.08,6.989-1.08,6.989 l11.389,0.758L334.182,125.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M317.612,133.178c-0.005,0-0.01,0-0.016-0.001c-0.138-0.008-0.242-0.127-0.234-0.265 c0.01-0.17,0.286-4.193,2.714-6.717c5.869-6.098,12.75-1.04,14.719,0.656c0.105,0.09,0.117,0.248,0.026,0.353 c-0.091,0.105-0.248,0.116-0.353,0.026c-1.885-1.623-8.467-6.47-14.032-0.688c-2.299,2.389-2.573,6.361-2.576,6.401 C317.853,133.075,317.743,133.178,317.612,133.178z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M331.853,143.033c-0.012,1.618-0.737,3.202-1.655,4.277c-1.382,1.616-2.966,0.82-3.329-0.972 c-0.327-1.613-0.003-4.397,1.744-5.373C330.333,140.004,331.867,141.183,331.853,143.033z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.053,219.122c0,0,0.534,58.144,5.578,90.545c4.074,26.17,11.613,86.689,11.613,86.689h11.422 c0,0,1.116-58.424-0.952-84.308c-5.233-65.498,8.271-77.743-2.626-92.926H330.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M330.053,219.122c0,0,0.534,58.144,5.578,90.545 c4.074,26.17,11.613,86.689,11.613,86.689h11.422c0,0,1.116-58.424-0.952-84.308c-5.233-65.498,8.271-77.743-2.626-92.926 H330.053z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M336.057,245.5c4.01,17.55,0.81,45.19-1.38,57.36c-2.32-18.48-3.49-42.43-4.07-59.98 C332.677,239.52,334.637,239.3,336.057,245.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "345.681,396.582 360.23,396.582 360.994,391.478 345.598,390.957  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M349.833,170.042c1.368-2.721,8.725-4.433,12.746-4.427l3.01,13.365 c0,0-8.012,11.89-11.343,10.629C350.31,188.122,346.901,175.872,349.833,170.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M349.833,170.042c1.368-2.721,8.725-4.433,12.746-4.427l3.01,13.365c0,0-8.012,11.89-11.343,10.629 C350.31,188.122,346.901,175.872,349.833,170.042z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M341.353,393.313c0.036-0.059,0.039-0.134,0.006-0.196c-0.039-0.074-0.121-0.116-0.205-0.103 c-0.42,0.063-4.122,0.651-4.622,1.708c-0.097,0.205-0.083,0.421,0.039,0.625c0.204,0.341,0.493,0.533,0.858,0.57 c1.213,0.125,2.965-1.558,3.901-2.572C341.338,393.334,341.346,393.324,341.353,393.313z M336.912,394.85 c0.342-0.561,2.256-1.078,3.717-1.347c-1.319,1.341-2.481,2.088-3.161,2.018c-0.238-0.025-0.42-0.149-0.558-0.379 c-0.054-0.09-0.06-0.167-0.02-0.251C336.897,394.877,336.904,394.863,336.912,394.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M341.353,393.313c0.008-0.012,0.014-0.026,0.018-0.04c0.023-0.066,0.008-0.14-0.037-0.193 c-0.063-0.073-1.546-1.782-2.913-1.871c-0.419-0.027-0.785,0.097-1.09,0.37c-0.411,0.368-0.376,0.688-0.273,0.891 c0.433,0.858,3.093,1.157,4.166,0.934C341.278,393.392,341.324,393.359,341.353,393.313z M337.438,392.054 c0.031-0.051,0.081-0.111,0.158-0.18c0.225-0.202,0.487-0.29,0.799-0.269c0.898,0.059,1.919,0.988,2.383,1.461 c-1.185,0.1-3.106-0.26-3.366-0.775C337.397,392.26,337.358,392.184,337.438,392.054z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "350.083,389.765 342.422,393.168 339.008,386.063 334.547,376.759 334.024,375.677  341.676,372.269 342.268,373.487 346.593,382.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "346.593,382.497 339.008,386.063 334.547,376.759 342.268,373.487  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M321.069,219.122c0,0-24.474,60.835-17.84,89.482c5.995,25.89,32.504,74.921,32.504,74.921 l10.25-5.145c0,0-16.388-59.188-18.166-72.046c-3.459-25.018,18.776-60.333,18.776-87.212L321.069,219.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M321.069,219.122c0,0-24.474,60.835-17.84,89.482 c5.995,25.89,32.504,74.921,32.504,74.921l10.25-5.145c0,0-16.388-59.188-18.166-72.046 c-3.459-25.018,18.776-60.333,18.776-87.212L321.069,219.122z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M341.055,392.103l7.608-5.538c0.277-0.202,0.642-0.173,0.877,0.069l5.248,5.389 c0.544,0.559,0.437,1.541-0.209,1.995c-2.686,1.885-4.078,2.66-7.423,5.095c-2.059,1.498-6.161,4.811-9.003,6.88 c-2.78,2.023-5.04-0.632-4.041-1.748c4.477-5.004,5.42-8.099,6.115-10.902C340.352,392.838,340.65,392.398,341.055,392.103z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "335.073,385.694 348.304,379.642 346.606,374.251 332.438,380.713  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M327.564,169.36c-1.098-2.841-10.657-5.957-15.452-7.045l-2.107,15.768 c0,0,7.831,11.255,11.27,10.324C325.335,187.308,329.916,175.447,327.564,169.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M327.564,169.36c-1.098-2.841-10.657-5.957-15.452-7.045l-2.107,15.768 c0,0,7.831,11.255,11.27,10.324C325.335,187.308,329.916,175.447,327.564,169.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M317.066,168.567c0,0-3.99,1.405,4.003,50.555c13.499,0,27.451,0,34.019,0 c-0.571-13.846-0.587-22.383,6.03-50.798c0,0-7.128-1.551-14.446-1.903c-5.725-0.276-10.415-0.459-15.448,0.001 C324.591,167.027,317.066,168.567,317.066,168.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M317.066,168.567c0,0-3.99,1.405,4.003,50.555c13.499,0,27.451,0,34.019,0 c-0.571-13.846-0.587-22.383,6.03-50.798c0,0-7.128-1.551-14.446-1.903c-5.725-0.276-10.415-0.459-15.448,0.001 C324.591,167.027,317.066,168.567,317.066,168.567z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M355.598,217.125l1.534,3.045c0.119,0.236-0.161,0.477-0.554,0.477h-35.677 c-0.307,0-0.561-0.15-0.58-0.343l-0.307-3.045c-0.021-0.211,0.245-0.39,0.58-0.39h34.45 C355.297,216.87,355.521,216.973,355.598,217.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M355.598,217.125l1.534,3.045c0.119,0.236-0.161,0.477-0.554,0.477h-35.677 c-0.307,0-0.561-0.15-0.58-0.343l-0.307-3.045c-0.021-0.211,0.245-0.39,0.58-0.39h34.45 C355.297,216.87,355.521,216.973,355.598,217.125z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.971,220.977h0.923c0.184,0,0.324-0.095,0.311-0.21l-0.433-3.956 c-0.013-0.116-0.173-0.21-0.357-0.21h-0.923c-0.184,0-0.324,0.095-0.311,0.21l0.433,3.956 C350.627,220.883,350.788,220.977,350.971,220.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M328.608,220.977h0.923c0.184,0,0.324-0.095,0.311-0.21l-0.433-3.956 c-0.013-0.116-0.173-0.21-0.357-0.21h-0.923c-0.184,0-0.324,0.095-0.311,0.21l0.433,3.956 C328.263,220.883,328.424,220.977,328.608,220.977z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsers);
export default __webpack_public_path__ + "static/media/no-users.5684479d4f057b2a12f36814e824ccff.svg";
export { ForwardRef as ReactComponent };